import React, { ChangeEvent } from 'react';
import { useRecoilState } from 'recoil';
import { TProjectConfigurationGeneralItem } from 'pages/common/types';
import { MainProduct as MainProductCommon } from 'pages/common/components/MainProduct';
import { savedConfigurationCalculationState } from '../../store/calculation';
import { MainProductBlock } from './styles';

export const MainProduct = () => {
  const [calculationFormState, setCalculationState] = useRecoilState(savedConfigurationCalculationState);
  const { mainProduct: product } = calculationFormState;

  if (Object.keys(product).length === 0) {
    return null;
  }

  const {
    image,
    code,
    name,
    quantity,
    price,
    productPageName,
  } = product as TProjectConfigurationGeneralItem;

  const handleChangeCounter = (_event: ChangeEvent<HTMLInputElement>, value: string): void => {
    setCalculationState(prevState => ({
      ...prevState,
      mainProduct: {
        ...product,
        quantity: Number(value),
      },
    }));
  };

  return (
    <MainProductBlock>
      <MainProductCommon
        photo={image}
        productId={code}
        displayedName={name}
        count={quantity.toString()}
        price={price * quantity}
        onChangeCounter={handleChangeCounter}
        productPageName={productPageName}
      />
    </MainProductBlock>
  );
};
